export enum Categories {
  All = 'All',
  TravelTips = 'Travel-Tips',
  TravelGuides = 'Travel-Guides',
  News = 'News',
  RoadTrips = 'Road-Trips',
  Comparisons = 'Comparisons',
  UserStories = 'User-Stories',
}

export type Category = keyof typeof Categories;

export type CategoriesSelectionProps = {
  activeCategories?: Category[];
  category: Category;
  onCategoryChange: (category: string) => void;
};
